import { render } from "./ModalEditHorasGlobal.vue?vue&type=template&id=4be9d391"
import script from "./ModalEditHorasGlobal.vue?vue&type=script&lang=js"
export * from "./ModalEditHorasGlobal.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__